import styled from 'styled-components';

const RecipientHeader = styled.div`
  align-items: center;
  align-self: flex-start;
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  gap: 8px;
  width: max-content;
`;

const RecipientsContent = styled.div`
  align-items: start;
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;

const BadgeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

export { BadgeWrapper, Col, RecipientHeader, RecipientsContent };
